// MB-I18N-2A / MB-I18N-POS — pos FR (clés plates, valeurs inchangées).
export default {
  "pos.tab.online_orders": "Commandes en ligne",
  "pos.tab.register": "Caisse",

  // Génériques POS
  "pos.loading": "Chargement de la caisse...",
  "pos.total": "Total",
  "pos.qr": "QR",
  "pos.time_min": "{time} min",
  "pos.items_count": "{count} article(s)",
  "pos.orders_count": "{count} commande(s)",
  "pos.points_pts": "{count} pts",

  // Actions
  "pos.action.view": "Voir",
  "pos.action.receipt": "Reçu",
  "pos.action.pay": "Payer",
  "pos.action.recharge": "Recharger",
  "pos.action.add": "Ajouter",
  "pos.action.in_cart": "Au panier",
  "pos.action.clear_cart": "Vider le panier",
  "pos.action.validate_reward": "Valider la récompense",
  "pos.action.view_recipe": "Voir recette",
  "pos.action.pause": "Pause",
  "pos.action.resume": "Reprendre",
  "pos.action.collapse": "Réduire",
  "pos.action.close": "Fermer",
  "pos.action.print": "Imprimer",
  "pos.action.mark_ready": "Marquer prêt",
  "pos.action.complete_credit": "Terminer & créditer points",
  "pos.action.validate_exchange": "Valider l'échange",
  "pos.action.link_customer": "Lier le client",
  "pos.action.link_loyalty_card": "Lier carte fidélité",
  "pos.action.add_to_cart": "Ajouter au panier",

  // Header / menu
  "pos.header.register_default": "Caisse enregistreuse",
  "pos.header.prep_screen": "Écran de préparation",
  "pos.role.owner": "Propriétaire",
  "pos.role.manager": "Manager",
  "pos.role.barista": "Barista",
  "pos.role.team": "Équipe",
  "pos.menu.actions_title": "Actions caisse",
  "pos.menu.tools": "Outils",
  "pos.menu.customer_mode": "Mode Client",
  "pos.menu.help": "Aide",
  "pos.menu.service": "Service",
  "pos.menu.refresh_orders": "Rafraîchir commandes",
  "pos.menu.last_receipt": "Dernier reçu",
  "pos.menu.closure": "Clôture caisse",
  "pos.menu.back_cockpit": "Retour au Cockpit",
  "pos.menu.logout": "Déconnexion",

  // Sélecteur de boutique
  "pos.shop_picker.title": "Sélectionnez votre boutique",

  // Catégories (onglets Plan de Travail)
  "pos.category.chaud": "Chaud",
  "pos.category.froid": "Froid",
  "pos.category.cookies": "Cookies",
  "pos.category.plats": "Plats",
  "pos.category.boulangerie": "Boulangerie",
  "pos.category.boissons": "Boissons",

  // Plan de Travail
  "pos.plan.price_todefine": "Prix à définir",
  "pos.plan.priority": "Prioritaires",
  "pos.plan.search_placeholder": "Rechercher un produit...",
  "pos.plan.empty_category": "Aucun produit dans cette catégorie",
  "pos.plan.unpriced_one": "{count} produit n'a pas encore de prix. Définissez-le dans Menu > Produits avant de le vendre.",
  "pos.plan.unpriced_many": "{count} produits n'ont pas encore de prix. Définissez-les dans Menu > Produits avant de les vendre.",

  // Fidélité (panneau caisse)
  "pos.loyalty.card": "Carte fidélité",
  "pos.loyalty.identify_customer": "Identifier un client",
  "pos.loyalty.scan_card": "Scanner carte fidélité",
  "pos.loyalty.enter_code_placeholder": "Entrer code client (SK-XXXX)",
  "pos.loyalty.rewards_title": "Récompenses fidélité",
  "pos.loyalty.rewards_hint": "Le client gagne des points à l'encaissement",
  "pos.loyalty.vip": "VIP",
  "pos.loyalty.balance": "Solde",
  "pos.loyalty.points": "Points",
  "pos.loyalty.requested_rewards": "Récompenses demandées",
  "pos.loyalty.points_count": "{count} points",
  "pos.loyalty.points_on_completion": "+{points} points à la complétion",
  "pos.loyalty.loyalty_badge": "Fidélité",
  "pos.loyalty.points_pending": "Points fidélité à la complétion",

  // Récompenses
  "pos.rewards.exchange": "Échanger récompense",
  "pos.rewards.dialog_title": "Échanger une récompense",
  "pos.rewards.none": "Aucune récompense accessible",
  "pos.rewards.one_max": "1 seule récompense par commande",

  // Mode de consommation (FR)
  "pos.consumption.dine_in": "Sur place",
  "pos.consumption.takeaway": "À emporter",

  // Panier
  "pos.cart.empty_title": "Panier vide",
  "pos.cart.empty_hint": "Cliquez sur un produit pour l'ajouter au ticket.",
  "pos.cart.test_hint_prefix": "Aucun client requis pour une vente test. Sélectionnez simplement un produit puis cliquez sur ",
  "pos.cart.free_badge": "OFFERT",
  "pos.cart.total_items": "Total ({count} articles)",
  "pos.cart.reward_with_order": "La récompense offerte sera validée avec la commande.",

  // Commandes (vue + états)
  "pos.orders.tab_new": "Nouvelles",
  "pos.orders.tab_ready": "Prêtes",
  "pos.orders.history": "Historique",
  "pos.orders.history_title": "Ouvrir l'historique des commandes dans le Cockpit",
  "pos.orders.empty_pending": "Aucune nouvelle commande",
  "pos.orders.empty_preparing": "Aucune commande en préparation",
  "pos.orders.empty_ready": "Aucune commande prête",
  "pos.orders.more_items": "+{count} autre(s)",

  // Statuts
  "pos.status.pending": "En attente",
  "pos.status.preparing": "En préparation",
  "pos.status.ready": "Prêt",
  "pos.status.completed": "Terminé",

  // Paiement
  "pos.payment.title": "Paiement - {amount}",
  "pos.payment.cash": "Espèces",
  "pos.payment.wallet": "Portefeuille",
  "pos.payment.wallet_short": "Wallet",
  "pos.payment.card_tpe": "CB (TPE)",
  "pos.payment.paid_card": "Payé CB",
  "pos.payment.paid_wallet": "Payé Wallet",
  "pos.payment.paid_cash": "Payé Cash",
  "pos.payment.paid": "Payé",
  "pos.payment.unpaid": "Non payé",
  "pos.payment.pending": "Paiement en attente",
  "pos.payment.required_before_complete": "Paiement requis avant de terminer",
  "pos.payment.amount_received": "Montant reçu ({currency})",
  "pos.payment.amount_in": "Montant en {currency}",
  "pos.payment.change_label": "Monnaie à rendre",
  "pos.payment.exact_amount": "Montant exact ({amount})",
  "pos.payment.insufficient_balance_excl": "Solde insuffisant!",
  "pos.payment.confirm": "Confirmer paiement",

  // Reçu
  "pos.receipt.total_ht": "Total HT",
  "pos.receipt.vat": "TVA ({rate} %)",
  "pos.receipt.total_ttc": "Total TTC",
  "pos.receipt.total": "TOTAL",
  "pos.receipt.cash_received": "Espèces reçues",
  "pos.receipt.change_given": "Monnaie rendue",
  "pos.receipt.customer": "Client : {name}",
  "pos.receipt.thanks": "Merci de votre visite!",

  // Recharge portefeuille
  "pos.recharge.title": "Recharger le portefeuille",
  "pos.recharge.current_balance": "Solde actuel: {balance}",
  "pos.recharge.amount": "Montant à recharger ({currency})",
  "pos.recharge.amount_placeholder": "Montant",

  // Temps de préparation
  "pos.prep_time.title": "Temps de préparation",
  "pos.prep_time.select": "Sélectionnez le temps de préparation estimé :",
  "pos.prep_time.minutes": "minutes",

  // Offre de bienvenue
  "pos.welcome_offer.title": "Offre de bienvenue !",
  "pos.welcome_offer.free_espresso": "1 Espresso OFFERT",
  "pos.welcome_offer.ok": "Super !",

  // Paiement CB (TPE)
  "pos.card_payment.title": "Paiement CB (TPE)",
  "pos.card_payment.ref_label": "Référence ticket TPE (optionnel)",
  "pos.card_payment.ref_placeholder": "Ex: TPE_123456",
  "pos.card_payment.hint": "Utilisez le terminal TPE pour encaisser le paiement, puis confirmez ici.",
  "pos.card_payment.confirm": "Confirmer paiement CB",

  // Rattachement client
  "pos.attach.title": "Lier client à la commande",
  "pos.attach.loyalty_note": "Points fidélité",
  "pos.attach.code_label": "Code carte fidélité du client",
  "pos.attach.code_placeholder": "SK-XXXXXXXX",
  "pos.attach.hint": "Scannez la carte ou demandez le code au client (visible dans son wallet).",

  // Scanner fidélité
  "pos.loyalty_scanner.scan": "Scanner",
  "pos.loyalty_scanner.manual": "Saisie manuelle",
  "pos.loyalty_scanner.activate_camera": "Activer caméra",
  "pos.loyalty_scanner.frame_hint": "Placez le QR code de la carte fidélité dans le cadre",
  "pos.loyalty_scanner.or_code_placeholder": "Ou entrer le code SK-XXXX",
  "pos.loyalty_scanner.code_label": "Code carte fidélité",
  "pos.loyalty_scanner.manual_hint": "Le code se trouve sur la carte fidélité du client ou dans son application wallet.",

  // Échanges à valider (tiroir)
  "pos.redemptions.title": "Échanges à valider",
  "pos.redemptions.description": "Récompenses demandées par vos clients, en attente de validation au comptoir.",
  "pos.redemptions.points_balance": "Solde points",
  "pos.redemptions.requested_at": "Demandé",
  "pos.redemptions.insufficient_now": "Points insuffisants au moment T",

  // Clôture de caisse
  "pos.closure.title": "Clôture de caisse",
  "pos.closure.generated_at": "Généré le {date}",
  "pos.closure.no_orders": "Aucune commande payée pour cette date",
  "pos.closure.export_pdf": "Exporter PDF",
  "pos.closure.pdf_date": "Date : {date}",
  "pos.closure.pdf_generated": "Généré le : {datetime}",
  "pos.closure.pdf_details": "Détail des paiements",
  "pos.closure.pdf_footer": "Généré automatiquement par Superkawa POS.",
  "pos.closure.pdf_exported": "PDF exporté: {file}",
  "pos.closure.pdf_error": "Erreur lors de l'export PDF",

  // Options produit
  "pos.options.title": "Options",
  "pos.options.size": "Taille",
  "pos.options.unit_price": "Prix unitaire",
  "pos.options.option": "Option",
  "pos.options.vanilla_ice": "Glace vanille",

  // Recette
  "pos.recipe.title": "Recette",
  "pos.recipe.loading": "Chargement…",
  "pos.recipe.difficulty": "Difficulté :",
  "pos.recipe.ingredients": "Ingrédients",
  "pos.recipe.steps": "Étapes",
  "pos.recipe.tip": "ASTUCE",

  // Affichage client (overlay)
  "pos.customer_view.card_bank": "Carte bancaire",
  "pos.customer_view.paid": "Paiement reçu — Merci !",
  "pos.customer_view.awaiting": "En attente de paiement",
  "pos.customer_view.welcome": "Bienvenue",
  "pos.customer_view.order_here": "Votre commande s'affichera ici",

  // Mini-file des commandes
  "pos.miniqueue.empty": "Aucune commande en cours",
  "pos.miniqueue.in_progress": "En cours",
  "pos.miniqueue.to_process": "À traiter",
  "pos.miniqueue.link": "Lier",
  "pos.miniqueue.link_title": "Lier une carte fidélité",
  "pos.miniqueue.collect": "Encaisser",
  "pos.miniqueue.collect_title": "Encaisser cette commande",
  "pos.miniqueue.card_tpe": "Carte (TPE)",
  "pos.miniqueue.choose_preptime": "Choisir le temps de préparation",
  "pos.miniqueue.more": "+{count} autre(s)",
  "pos.miniqueue.just_now": "à l'instant",
  "pos.miniqueue.minutes_short": "{count} min",
  "pos.miniqueue.hours_short": "{count} h",
  "pos.miniqueue.status_pending": "Nouvelle",
  "pos.miniqueue.status_preparing": "En préparation",
  "pos.miniqueue.status_ready": "Prête",
  "pos.miniqueue.action_prepare": "Préparer",
  "pos.miniqueue.action_ready": "Prêt",
  "pos.miniqueue.action_finish": "Terminer",

  // Toasts / messages frontend
  "pos.toast.load_error": "Erreur de chargement des données",
  "pos.toast.new_order": "Nouvelle commande",
  "pos.toast.validation_error": "Erreur validation",
  "pos.toast.service_paused": "Service en pause",
  "pos.toast.service_resumed": "Service repris",
  "pos.toast.status_change_error": "Erreur lors du changement de statut",
  "pos.toast.closed_by_manager": "Cette boutique a été fermée par un responsable — seul un owner ou manager peut la rouvrir",
  "pos.toast.price_undefined": "Prix à définir — réglez le prix dans Admin > Produits avant de vendre",
  "pos.toast.reward_not_editable": "Récompense non modifiable. Annulez la commande pour la retirer.",
  "pos.toast.recipe_unavailable": "Recette indisponible",
  "pos.toast.no_active_shop": "Boutique active introuvable — reconnectez-vous ou sélectionnez une boutique",
  "pos.toast.customer_not_found": "Client non trouvé",
  "pos.toast.one_reward_max": "1 seule récompense par commande",
  "pos.toast.insufficient_points": "Points insuffisants",
  "pos.toast.redeem_error": "Erreur échange",
  "pos.toast.reward_added": "{name} ajouté au ticket",
  "pos.toast.invalid_code": "Code invalide",
  "pos.toast.camera_error": "Impossible d'accéder à la caméra",
  "pos.toast.card_payment_error": "Erreur de paiement CB",
  "pos.toast.payment_collected": "Paiement encaissé",
  "pos.toast.payment_error": "Erreur de paiement",
  "pos.toast.no_shop_selected": "Aucune boutique active sélectionnée",
  "pos.toast.loading_error": "Erreur de chargement",
  "pos.toast.no_data_export": "Aucune donnée à exporter",
  "pos.toast.empty_cart": "Panier vide",
  "pos.toast.customer_required_wallet": "Client requis pour paiement par portefeuille",
  "pos.toast.insufficient_balance": "Solde insuffisant",
  "pos.toast.sale_completed": "Vente encaissée · #{number}",
  "pos.toast.reward_validated": "Récompense validée",
  "pos.toast.reward_validation_error": "Erreur de validation de la récompense",
  "pos.toast.wallet_recharged": "Portefeuille rechargé de {amount}",
  "pos.toast.recharge_error": "Erreur de recharge",
  "pos.toast.order_accepted": "Commande acceptée - {min} min",
  "pos.toast.update_error": "Erreur de mise à jour",
  "pos.toast.order_completed_points": "Commande terminée! +{points} points fidélité",
};
